angular.module('impactx.lot').controller('LotSupplierListCtrl',
    LotSupplierListCtrl);

LotSupplierListCtrl.$inject = ['$routeParams', 'selectedListItems', 'BackService', 'BackFactory'];

function LotSupplierListCtrl($routeParams, selectedListItems, BackService, BackFactory)
{
    BackFactory.setLotSupplierId(0);

    var ctrl = this;

    this.getDetailLink = function() {
        if (selectedListItems.getFirstSelectedItem())
        {
            return "lotsupplierdetail/" + selectedListItems.getFirstSelectedItem().id + "/"  + selectedListItems.getFirstSelectedItem().lotId;
        }
        return "";
    };

    this.getSubSupplierLink = function() {
        if (selectedListItems.getFirstSelectedItem())
        {
            return "lotsubsupplierlist/" + selectedListItems.getFirstSelectedItem().id;
        }
        return "";
    };

    this.backFunction = function () {
        BackFactory.setLotId($routeParams.lotId);
        BackService.back();
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'ViewLotSupplier'},
        {label: "lotSubSupplier", linkFunction: ctrl.getSubSupplierLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'ListLotSubSupplier'}
    ];


    this.meta = {
        rowTemplate: 'modules/lot/templates/lotsupplierlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/lot/supplierlist',
        id: "lotsupplierlist",
        valuesInteger: [{name:"LOT_Id", value: $routeParams.lotId}],
        mainAction : {id:"new", link: "#/lotsupplierdetail/0/" + $routeParams.lotId + "/", icon:"mdi-plus"},
        backFunction: ctrl.backFunction,
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    }
}